import React from "react";
import { Pagination, Form, Row, Col } from "react-bootstrap";

const Paginate = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
}) => {
  const renderPageItems = () => {
    const items = [];

    // Always show page 1
    items.push(
      <Pagination.Item
        key={1}
        active={currentPage === 1}
        onClick={() => onPageChange(1)}
      >
        1
      </Pagination.Item>
    );

    // Show ellipsis if gap between 1 and left adjacent page > 1
    if (currentPage - 1 > 2) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    // Show left adjacent page if it exists and is not 1
    const leftPage = currentPage - 1;
    if (leftPage > 1) {
      items.push(
        <Pagination.Item key={leftPage} onClick={() => onPageChange(leftPage)}>
          {leftPage}
        </Pagination.Item>
      );
    }

    // Show current page if not first or last (because they are always shown separately)
    if (currentPage !== 1 && currentPage !== totalPages) {
      items.push(
        <Pagination.Item key={currentPage} active>
          {currentPage}
        </Pagination.Item>
      );
    }

    // Show right adjacent page if it exists and is not last
    const rightPage = currentPage + 1;
    if (rightPage < totalPages) {
      items.push(
        <Pagination.Item
          key={rightPage}
          onClick={() => onPageChange(rightPage)}
        >
          {rightPage}
        </Pagination.Item>
      );
    }

    // Show ellipsis if gap between right adjacent page and last page > 1
    if (currentPage + 1 < totalPages - 1) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    // Always show last page if more than 1
    if (totalPages > 1) {
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div className="paginationbx" style={{overflowX: 'hidden'}}>
      <Row className="align-items-center">
        <Col xs="auto">
          <Form.Select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            size="sm"
          >
            <option value="5">5 / page</option>
            <option value="10">10 / page</option>
            <option value="20">20 / page</option>
            <option value="50">50 / page</option>
          </Form.Select>
        </Col>

        <Col>
          <Pagination className="justify-content-end mb-0">
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}
            />
            {renderPageItems()}
            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}
            />
          </Pagination>
        </Col>
      </Row>
    </div>
  );
};

export default Paginate;
